// Libraries
import React from 'react';
import { Field } from 'redux-form';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

// Component
import { FormElems } from '../../components/';

import {
    createEntityError,
    fetchEntityListRequest,
    fetchEntityHierarchyRequest,
} from '../../containers/MerchantOnboard/redux/merchantOnBoard.actions';

const AddRole = props => {
    const {
        data,
        onRoleSelect,
        isViewMode,
        entitySelectedValue,
        hierarchyLoader,
        handleResetSection,
        error,
        handleSearchEnd,
    } = props;

    return (
        <div className="form-field">
            <p className="label"> {data.label}</p>
            <Field
                name={data.name}
                {...data.props}
                input={false}
                wrapperClass={data.name}
                loader={hierarchyLoader}
                component={FormElems.SearchSelectEnhanced}
                selected={entitySelectedValue}
                handleChange={(value, originalData) => {
                    onRoleSelect(value, originalData, data.type);
                }}
                disabled={isViewMode}
                handleReset={() => {
                    handleResetSection(data.type);
                }}
                handleSearchEnd={value => handleSearchEnd(value, data.name)}
            />
            <p className={'custom-error-message'}>{error}</p>
        </div>
    );
};

AddRole.propTypes = {
    actions: PropTypes.object,
    data: PropTypes.object,
    onRoleSelect: PropTypes.func,
    isViewMode: PropTypes.bool,
    entitySelectedValue: PropTypes.string,
    setEntityValues: PropTypes.func,
    id: PropTypes.string,
    hierarchyLoader: PropTypes.number,
    handleSearchEnd: PropTypes.func,
    handleResetSection: PropTypes.func,
    error: PropTypes.string,
};

const mapStateToProps = ({ auth }) => ({
    auth,
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(
        {
            createEntityError,
            fetchEntityListRequest,
            fetchEntityHierarchyRequest,
        },
        dispatch
    ),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddRole);
